<ng-container *mdAutorun>
  <div
    data-test="CflWJS0Y"
    class="search-wrap"
    style="position: relative"
    *ngIf="filters && filterValues"
  >
    <md-search-field
      data-test="KSGr2LSw"
      classes="search-top_no-label search-top_full search-top_input"
      *mdAutorun
      [alwaysActive]="true"
      [showFilterButton]="true"
      [filterButtonActive]="isFiltersActive"
      (toggleFilter)="toggleFiltersActive()"
      (search)="handleSearch($event)"
    ></md-search-field>
    <div
      data-test="7xmjKEM8"
      class="dropdown pt-0 w-100 show active"
      [class.active]="isFiltersActive"
      *mdAutorun
    >
      <div
        data-test="sBV1rfz5"
        class="dropdown__wrap p-0"
        style="max-height: 75vh"
        data-simplebar
      >
        <div data-test="2HEeeH8r" class="container-fluid py-3">
          <form data-test="oguANyjq" class="form m-0">
            <ng-container *ngFor="let filter of getFiltersList(); trackBy: trackControl">
              <div
                data-test="lQoBOWRX"
                *ngIf="isDropdown(filter.value) && getDropdown(filter.value) as value"
                class="form-group"
              >
                <label
                  data-test="EzSHkJbq"
                  class="form-group__label form-group__label_sm"
                >
                  {{ value.label || (filter.key | humanizeTextCode) }}
                </label>
                <md-dropdown
                  data-test="o1bAslaK"
                  placeholder="Any"
                  [dropdownClasses]="value.dropdownClasses || 'dropdown_default'"
                  labelKey="label"
                  valueKey="value"
                  *mdAutorun
                  [ngModel]="filterValues[filter.key]"
                  [ngModelOptions]="{ standalone: true }"
                  (valueChange)="
                    changeFilterValue(
                      $any({
                        name: filter.key,
                        newValue: $event
                      })
                    )
                  "
                  [canClear]="value.canClear"
                  [options]="value.items | toJS"
                ></md-dropdown>
              </div>
              <div
                data-test="v80g5n7G"
                *ngIf="
                  isDropdownMultiple(filter.value) &&
                  getDropdownMultiple(filter.value) as value
                "
                class="form-group"
              >
                <label
                  data-test="0MGYOmq0"
                  class="form-group__label form-group__label_sm"
                >
                  {{ value.label || (filter.key | humanizeTextCode) }}
                </label>
                <md-dropdown
                  data-test="9zu3QCRa"
                  placeholder="Any"
                  [dropdownClasses]="value.dropdownClasses || 'dropdown_default'"
                  labelKey="label"
                  valueKey="value"
                  *mdAutorun
                  [ngModel]="filterValues[filter.key] | toJS"
                  [ngModelOptions]="{ standalone: true }"
                  [multiple]="true"
                  [canClear]="value.canClear"
                  [options]="value.items | toJS"
                  [joinMultipleLables]="true"
                  (valueChange)="
                    changeFilterValue(
                      $any({
                        name: filter.key,
                        newValue: $event
                      })
                    )
                  "
                ></md-dropdown>
              </div>

              <div
                data-test="GRBRUPrE"
                *ngIf="
                  isDropdownExternal(filter.value) &&
                  getDropdownExternal(filter.value) as value
                "
                class="form-group"
              >
                <label
                  data-test="04_mlAz4"
                  class="form-group__label form-group__label_sm"
                >
                  {{ value.label || (filter.key | humanizeTextCode) }}
                </label>
                <md-dropdown
                  data-test="GMtXcMLi"
                  placeholder="Any"
                  [dropdownClasses]="value.dropdownClasses || 'dropdown_default'"
                  labelKey="label"
                  valueKey="value"
                  *mdAutorun
                  [ngModel]="filterValues[filter.key]"
                  [ngModelOptions]="{ standalone: true }"
                  (valueChange)="
                    changeFilterValue(
                      $any({
                        name: filter.key,
                        newValue: $event
                      })
                    )
                  "
                  [canClear]="value.canClear"
                  [canAdd]="value.canAdd"
                  [labelKey]="value.labelKey"
                  [valueKey]="value.valueKey"
                  [url]="value.url"
                ></md-dropdown>
              </div>

              <div
                data-test="it9vCzn3"
                *ngIf="
                  isDropdownExternalMultiple(filter.value) &&
                  getDropdownExternalMultiple(filter.value) as value
                "
                class="form-group"
              >
                <label
                  data-test="r_1IsAd-"
                  class="form-group__label form-group__label_sm"
                >
                  {{ value.label || (filter.key | humanizeTextCode) }}
                </label>
                <md-dropdown
                  data-test="VRgJ8BZs"
                  placeholder="Any"
                  [dropdownClasses]="value.dropdownClasses || 'dropdown_default'"
                  labelKey="label"
                  valueKey="value"
                  *mdAutorun
                  [ngModel]="filterValues[filter.key] | toJS"
                  [hideSelected]="true"
                  [ngModelOptions]="{ standalone: true }"
                  [multiple]="true"
                  [canClear]="value.canClear"
                  [canAdd]="value.canAdd"
                  [labelKey]="value.labelKey"
                  [valueKey]="value.valueKey"
                  [url]="value.url"
                  [disableCache]="true"
                  (valueChange)="
                    changeFilterValue(
                      $any({
                        name: filter.key,
                        newValue: $event
                      })
                    )
                  "
                  #dropdownExternalMultipleRef
                >
                  <ng-template let-chosenOptions mdTemplate="selected">
                    <div data-test="d4eP0UGn" class="field-tag">
                      <div
                        data-test="mpAPLEG7"
                        class="input input_tags input_sm"
                        *ngIf="
                          dropdownExternalMultipleRef.chosenOptions.length > 0;
                          else dropdownExternalMultipleEmpty
                        "
                      >
                        <div
                          data-test="9OMdq4wD"
                          class="field-tag__item"
                          data-label="item"
                          *ngFor="
                            let option of dropdownExternalMultipleRef.chosenOptions;
                            trackBy: trackControl
                          "
                        >
                          <div data-test="i47v--ED" class="label label_blue">
                            <span data-test="zcB23mv3">
                              {{ dropdownExternalMultipleRef.getOptionLabel(option) }}
                            </span>
                            <span
                              data-test="5fFlNEoM"
                              class="label__append"
                              (click)="
                                $event.stopPropagation();
                                dropdownExternalMultipleRef.selectValue(option)
                              "
                            >
                              <i data-test="SOvQbild" class="material-icons">close</i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <ng-template #dropdownExternalMultipleEmpty>
                        <input
                          data-test="CT5IwHVo"
                          class="input input_sm"
                          placeholder="any"
                        />
                      </ng-template>
                    </div>
                  </ng-template>
                </md-dropdown>
              </div>
              <div
                data-test="U1VhlCcT"
                class="form-group"
                *ngIf="
                  isLocationRange(filter.value) && getLocationRange(filter.value) as value
                "
              >
                <label
                  data-test="V2QZ4E7J"
                  class="form-group__label form-group__label_sm"
                >
                  <div data-test="GlgKy_7E" class="row">
                    <div data-test="QRg7etXy" class="col-5">
                      {{ value.label || (filter.key | humanizeTextCode) }}
                      ({{ value.measuringSystemLabel || 'km' }})
                    </div>
                    <div data-test="H_n90bmn" class="col text-right">
                      <div data-test="TQClLLyT" class="text-light font-weight-normal">
                        {{ value.minLabel || 'min' }}
                        <span data-test="clYTb82j" class="ml-2 invisible">
                          {{ value.measuringSystemLabel || 'km' }}
                        </span>
                      </div>
                    </div>
                    <div data-test="xJMnZhBW" class="col text-right">
                      <div data-test="F2TaviSM" class="text-light font-weight-normal">
                        {{ value.maxLabel || 'max' }}
                        <span data-test="ANcLStYc" class="ml-2 invisible">
                          {{ value.measuringSystemLabel || 'km' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </label>
                <div
                  data-test="FfbkVWnr"
                  class="row align-items-center mb-2"
                  *ngFor="
                    let location of getLocationRangeItems(value);
                    trackBy: trackControl
                  "
                >
                  <div data-test="zwZfAS5Z" class="col-5">
                    {{ location.value.label || (location.key | humanizeTextCode) }}
                  </div>
                  <div data-test="km32VKjq" class="col d-flex align-items-center">
                    <div data-test="jL7HHs-o" class="form-group__field">
                      <input
                        data-test="OnPIhQOs"
                        class="input input_sm"
                        type="number"
                        min="0"
                        [ngModel]="
                          DistanceUtils.fromMetre(
                            $any(filterValues[filter.key])[location.key].from
                          )
                        "
                        [ngModelOptions]="{ standalone: true }"
                        (keypress)="avoidNegativeNumber($event)"
                        (change)="
                          changeLocationRangeValue({
                            filterName: filter.key,
                            locationName: location.key,
                            event: $event,
                            type: 'from'
                          })
                        "
                      />
                    </div>
                    <div data-test="5eBhc806" class="text-light ml-2">
                      {{ value.measuringSystemLabel || 'km' }}
                    </div>
                  </div>
                  <div data-test="Sz62NawL" class="col d-flex align-items-center">
                    <div data-test="DGnIUa5H" class="form-group__field">
                      <input
                        data-test="X7klyu5T"
                        class="input input_sm"
                        type="number"
                        min="0"
                        [ngModel]="
                          DistanceUtils.fromMetre(
                            $any(filterValues[filter.key])[location.key].to
                          )
                        "
                        [ngModelOptions]="{ standalone: true }"
                        (keypress)="avoidNegativeNumber($event)"
                        (change)="
                          changeLocationRangeValue({
                            filterName: filter.key,
                            locationName: location.key,
                            event: $event,
                            type: 'to'
                          })
                        "
                      />
                    </div>
                    <div data-test="mU50ZdmH" class="text-light ml-2">
                      {{ value.measuringSystemLabel || 'km' }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                data-test="BJM1cbbD"
                class="form-group search-filter--range"
                *ngIf="isRange(filter.value) && getRange(filter.value) as value"
              >
                <label
                  data-test="0XTN-NEm"
                  class="form-group__label form-group__label_sm"
                >
                  {{ value.label || (filter.key | humanizeTextCode) }}
                </label>
                <ngx-slider
                  data-test="5v_PSScA"
                  (userChange)="
                    changeFilterValue(
                      $any({
                        name: filter.key,
                        newValue: { min: $event.value, max: $event.highValue }
                      })
                    )
                  "
                  [value]="$any(filterValues[filter.key]).min"
                  [highValue]="$any(filterValues[filter.key]).max"
                  [options]="{
                    floor: min($any(filterValues[filter.key]).min, value.min),
                    ceil: max($any(filterValues[filter.key]).max, value.max)
                  }"
                ></ngx-slider>
              </div>
            </ng-container>
            <div data-test="wGHMAmDo" class="row gutters-16 justify-content-end mt-4">
              <div data-test="WTIMBGUX" class="col-auto">
                <button
                  data-test="WjTNrBkk"
                  type="button"
                  class="button button_sm button_secondary"
                  (click)="resetFilters()"
                >
                  Reset
                </button>
              </div>
              <div data-test="ZeMpv8_S" class="col-auto">
                <button
                  data-test="xQPEMlE1"
                  type="button"
                  class="button button_sm button_primary"
                  (click)="applyFilters()"
                >
                  Search
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</ng-container>
